import React, {useState} from 'react';
import WarningIcon from '@mui/icons-material/Warning';
import { Alert } from '@mui/material';

// This component is meant to fix a bug with the alert note display on legacy AccountReports. 
// It can be removed once AccountReport (specifically SupplierInventoryReport) is redesigned. -EL
const MobileFriendlyAccountReportAlertNote = ({message}) => {
    const [displayWarning, setDisplayWarning] = useState(false);

    return <div className="ss-mobile-friendly-alert-note-container">
        <WarningIcon
            onClick={() => setDisplayWarning(prev => !prev)}
            fontSize='large'
            className={"ss-mobile-friendly-alert-note-icon"}
            role="button"
            tabIndex={0}
            aria-label="Toggle warning message"
        />
        <Alert severity={'warning'} className={`${displayWarning ? "ss-mobile-friendly-alert-note-override-display" : ''} ss-mobile-friendly-alert-note d-flex flex-wrap`}>{message}</Alert>
    </div>
};

export default MobileFriendlyAccountReportAlertNote;
